import React from 'react';

const PlaybookIcon = ({ width = 24, height = 19, color = 'white', ...props }) => (
  <svg width={width} height={width} viewBox={`0 0 ${width} ${height}`} fill="none" {...props}>
    <path
      d="M3.67094 0.000101089C3.6703 0.000101089 3.66957 0.000101089 3.66892 0.000101089C3.44193 0.000101089 3.22843 0.0885862 3.06722 0.249395C2.90423 0.411981 2.81445 0.628467 2.81445 0.858932V13.737C2.81445 14.2092 3.20015 14.5943 3.67434 14.5955C5.67337 14.6003 9.02256 15.017 11.333 17.4348V3.95761C11.333 3.79753 11.2921 3.64714 11.215 3.5227C9.31864 0.468789 5.67451 0.00478797 3.67094 0.000101089Z"
      fill={color}
    />
    <path
      d="M21.1855 13.7369V0.858831C21.1855 0.628366 21.0957 0.41188 20.9327 0.249294C20.7715 0.0884851 20.5578 0 20.3311 0C20.3304 0 20.3296 0 20.329 0C18.3255 0.00476769 14.6814 0.468769 12.785 3.52268C12.7078 3.64712 12.667 3.79751 12.667 3.95759V17.4347C14.9775 15.0169 18.3266 14.6002 20.3257 14.5954C20.7998 14.5942 21.1855 14.2091 21.1855 13.7369Z"
      fill={color}
    />
    <path
      d="M23.1406 2.9699H22.5179V13.7369C22.5179 14.9426 21.5355 15.9258 20.3279 15.9288C18.6323 15.9329 15.8365 16.2644 13.8564 18.1384C17.2809 17.3 20.891 17.845 22.9484 18.3139C23.2053 18.3724 23.4707 18.3119 23.6765 18.1479C23.8816 17.9843 23.9993 17.7397 23.9993 17.4771V3.82857C23.9994 3.35512 23.6141 2.9699 23.1406 2.9699Z"
      fill={color}
    />
    <path
      d="M1.48138 13.7369V2.9699H0.85867C0.385294 2.9699 0 3.35512 0 3.82857V17.4769C0 17.7395 0.117657 17.984 0.322749 18.1477C0.528406 18.3116 0.793619 18.3723 1.05091 18.3136C3.10829 17.8447 6.71841 17.2997 10.1427 18.1382C8.16278 16.2643 5.36697 15.9328 3.67137 15.9287C2.46385 15.9258 1.48138 14.9426 1.48138 13.7369Z"
      fill={color}
    />
  </svg>
);

export default PlaybookIcon;
